import React from 'react';

const TableHeader = ({
  zones,
  index,
  totalLength,
  itemKey,
  doc2Visibility,
  toggleDoc2Visibility,
  theadStyle,
  returnDoc2Zones
}) => {
  return (
    <thead>
      <th style={theadStyle}>
        {returnDoc2Zones(zones["Zone 1"])} vs. {returnDoc2Zones(zones["Zone 2"])}&nbsp; 
        ({index + 1}&nbsp;of&nbsp;{totalLength})
        
        <div
          style={{
            fontStyle: 'italic',
            fontSize: '13px',
            color: '#526666',
            padding: '2px 0px',
            display: 'inline',
            margin: '2px',
            float: 'right',
            cursor: 'pointer',
            zIndex: '999'
          }}
          onClick={() => toggleDoc2Visibility(itemKey)}
        >
          Expand
          <span
            style={{
              marginLeft: '8px',
              display: 'inline-block',
              width: '0',
              height: '0',
              zIndex: '999',
              borderTop: '4px solid transparent',
              borderBottom: '4px solid transparent',
              borderLeft: '8px solid #526666',
              transform: doc2Visibility[itemKey] ? 'rotate(90deg)' : 'rotate(0deg)',
              transformOrigin: '4px 50%',
              transition: 'transform 0.2s ease',
            }}
          ></span>
        </div>
      </th>
    </thead>
  );
};

export default TableHeader;
